import * as Yup from 'yup'
import { Partners } from '@shared/lib/partner'
import { Param } from '@root/api/ump-catalog-manager'
import { maxLSAmountLimit, maxSBPAmountLimit, minAmountLimit, PaymentMethod } from '@entities/payment'
import { isCardNumberValid } from '@shared/lib/validators'
import { messages } from './messages'

interface GetPurchaseFormValidationArgs {
  isShowVouchers: boolean
  fields: Param[]
  partner: Partners
  paymentMethod: PaymentMethod
}

export const getPurchaseFormValidation = ({
  isShowVouchers,
  fields,
  partner,
  paymentMethod,
}: GetPurchaseFormValidationArgs) => {
  const cdekValidationRules = {
    isPersonalDataAgreed: Yup.lazy(() => Yup.boolean().required().isTrue()),
    isMailingAgreed: Yup.lazy(() => Yup.boolean()),
  }

  const cardValidationRules = {
    cardNumber: Yup.lazy(() =>
      Yup.string().test('card-number', 'Некорректный номер карты', isCardNumberValid).required('Обязательное поле')
    ),
    expiryDate: Yup.lazy(() =>
      Yup.string()
        .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, 'Некорректный срок')
        .required('Обязательное поле')
    ),
    cvc: Yup.lazy(() =>
      Yup.string()
        .matches(/\d\d\d/, 'Некорректный CVV')
        .required('Обязательное поле')
    ),
  }

  const max = paymentMethod === PaymentMethod.SBP ? maxSBPAmountLimit : maxLSAmountLimit

  if (!isShowVouchers) {
    return Yup.object().shape({
      // -----------STEAM-----------
      price: Yup.lazy(() =>
        !isShowVouchers
          ? Yup.number()
              .typeError('Введите число')
              .min(minAmountLimit, `${messages.paymentAmount.min(minAmountLimit)} ₽`)
              .max(Number(max.split(' ').join('')), `${messages.paymentAmount.max(max)} ₽`)
              .required('Вначале заполните поле')
          : Yup.mixed().notRequired()
      ),
      login: Yup.lazy(() =>
        !isShowVouchers
          ? Yup.string()
              .test('no-email', 'Некорректные данные', (value) => /^[A-Za-z_0-9.@\s-]{3,50}$/.test(value as string))
              .required('Обязательное поле')
          : Yup.mixed().notRequired()
      ),
      ...(partner === Partners.DEFAULT && paymentMethod === PaymentMethod.CARD ? cardValidationRules : {}),
      promocode: Yup.lazy(() => Yup.string()),
      ...(partner === Partners.CDEK ? cdekValidationRules : {}),
    })
  }

  return Yup.object().shape({
    ...fields?.reduce((acc, cur) => {
      if (cur.name === 'id1' || cur.name === 'email') {
        ;(acc as any).email = Yup.lazy(() =>
          Yup.string()
            .email('Некорректный email')
            .test(
              'no-cyrillic',
              'Email не может содержать русские буквы',
              (value) => !/[а-яА-ЯёЁ]/.test(value as string)
            )
            .required('Вначале заполните поле')
        )
      } else {
        acc[cur.name] = Yup.lazy(() =>
          Yup.string()
            .test('unvalid-data', 'Некорректные данные', (value) =>
              new RegExp(cur.regExp as string).test(value as string)
            )
            .required('Обязательное поле')
        )
      }

      return acc
    }, {}),
    ...(partner === Partners.DEFAULT && paymentMethod === PaymentMethod.CARD ? cardValidationRules : {}),
    ...(partner === Partners.CDEK ? cdekValidationRules : {}),
  })
}
